/**
 * Safely checks if FullStory is available on the window object.
 * @returns {boolean}
 */
export function isFullStoryAvailable() {
  return typeof window !== 'undefined' && window.FS && typeof window.FS.event === 'function'
}

/**
 * Safely sends a custom event to FullStory, if available.
 * @param {string} eventName - The name of the event.
 * @param {object} [eventProps] - Optional properties to send with the event.
 */
export function sendFullStoryEvent(eventName, eventProps = {}) {
  try {
    if (isFullStoryAvailable()) {
      window.FS.event(eventName, eventProps)
    } else {
      console.error('Fullstory not available to send event', eventName, eventProps)
    }
  } catch (err) {
    console.error('Error sending FullStory event:', err, eventName, eventProps)
  }
}
